import { render, staticRenderFns } from "./asturkey.vue?vue&type=template&id=92968e74"
import script from "./asturkey.vue?vue&type=script&lang=js"
export * from "./asturkey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports